<!-- [フッター] -->
<footer class="l-footer">
  <div class="l-wrap">
    <div class="l-wrap__inner">
      <div class="l-footer__inner">
        <div class="l-footer__menu-area">
          <div class="l-footer-menu">
            <ul class="l-footer-menu__list"></ul>
          </div>
        </div>
        <div class="l-footer-desc"></div>
        <div class="l-footer-bottom">
          <div class="l-footer-bottom__logos-area">
            <div class="l-footer-logos"></div>
          </div>
          <div class="l-footer-bottom__copyright-area">
            <div class="l-footer-copyright" [innerHTML]="'message.copyrightAna' | staticMsg"></div>
          </div>
        </div>
        <div class="l-footer-page-top" (click)="onClickPageTop()">
          <a id="footer-top-scroll-button" class="l-footer-page-top__button" href="#" onclick="return false;"
            ><span class="l-footer-page-top__text" [innerHTML]="'label.pageTop' | staticMsg"></span
          ></a>
        </div>
      </div>
    </div>
  </div>
</footer>
<!-- [フッター] -->
